import { type FC } from "react";
import { Stack } from "@mui/material";
import { FilterProvider } from "@/partner/shared/components/Filter";
import { PaymentsFilter } from "./PaymentsFilter";
import { PaymentsList } from "./PaymentsList";

// Компоновка раздела как у features/users: FilterProvider → Stack →
// карточка фильтров → список.
export const Payments: FC = () => {
  return (
    <FilterProvider>
      <Stack spacing={1}>
        <PaymentsFilter />
        <PaymentsList />
      </Stack>
    </FilterProvider>
  );
};
